import { PaginationBaseValueConverter } from 'General/Resources/ValueConverters/PaginationBase';
export class PaginationValueConverter extends PaginationBaseValueConverter {

}